const IsRequiredValidation = (value) => {
  let validator = {
    isValid: true,
    class: "",
    error: "",
  };

  if (value.length < 1) {
    validator = {
      ...validator,
      isValid: false,
      class: "shipment-form-field-error",
      error: "Shipment Name is required",
    };
    return validator;
  }

  validator = {
    ...validator,
    isValid: true,
    class: "shipment-form-field-success",
    error: "",
  };
  return validator;
};

export { IsRequiredValidation };
